import React from "react";
import { FaInstagram, FaYoutube, FaBehance, FaLinkedin } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#111010] text-white  pt-[5vh] md:pt-[10vh] pb-[5vh] relative z-30">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Social Media Icons */}
        <div className="flex justify-center space-x-6 mb-6">
          <Link
            to="https://www.youtube.com/@rounakchowdhury13"
            target="_blank"
            className="bg-white text-black rounded-full p-2 hover:bg-gray-300 transition-all duration-300"
          >
            <FaYoutube size={20} />
          </Link>
          <Link
            to=""
            target="_blank"
            className="bg-white text-black rounded-full p-2 hover:bg-gray-300 transition-all duration-300"
          >
            <FaBehance size={20} />
          </Link>
          <Link
            to=""
            target="_blank"
            className="bg-white text-black rounded-full p-2 hover:bg-gray-300 transition-all duration-300"
          >
            <FaInstagram size={20} />
          </Link>
          <Link
            to=""
            target="_blank"
            className="bg-white text-black rounded-full p-2 hover:bg-gray-300 transition-all duration-300"
          >
            <FaLinkedin size={20} />
          </Link>
        </div>

        {/* Navigation Links */}
        <div className="flex justify-center space-x-8 mb-6">
          <Link
            to="/"
            className="hover:text-[#ae0c00] text-xs md:text-base transition-all duration-300"
          >
            Home
          </Link>
          <Link
            to="/work"
            className="hover:text-[#ae0c00] text-xs md:text-base transition-all duration-300"
          >
            Work
          </Link>
          <Link
            to="/about"
            className="hover:text-[#ae0c00] text-xs md:text-base transition-all duration-300"
          >
            About
          </Link>
          <Link
            to="/contact"
            className="hover:text-[#ae0c00] text-xs md:text-base transition-all duration-300"
          >
            Contact Us
          </Link>
          <Link
            to="/services"
            className="hover:text-[#ae0c00] text-xs md:text-base transition-all duration-300"
          >
            Our Services
          </Link>
        </div>

        {/* Copyright Section */}
        <div className="text-center text-gray-500 text-sm">
          <Link to="mailto:suprotiv.2003@gmail.com">
            <p>
              Copyright &copy; 2024{" "}
              <span className="text-white">Pal's Infotech</span>
            </p>
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
